// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dArray$dNonEmpty$dInternal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data$dArray$dNonEmpty$dSerialized from "../Data.Array.NonEmpty.Serialized/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dOrdered from "../Data.Map.Ordered/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dSet$dSerialized from "../Data.Set.Serialized/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dColor from "../Restaumatic.Menu.V2.Types.Color/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dMenuConsumer from "../Restaumatic.Menu.V2.Types.MenuConsumer/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPhoto from "../Restaumatic.Menu.V2.Types.Photo/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPreorderSettings from "../Restaumatic.Menu.V2.Types.PreorderSettings/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $MenuSectionItem = (tag, _1) => ({tag, _1});
const $SectionContent = (tag, _1) => ({tag, _1});
const eq = /* #__PURE__ */ (() => Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dEq.eqString).eq)();
const eq2 = /* #__PURE__ */ (() => Data$dMap$dInternal.eqMap(Restaumatic$dLocales.eqLocale)(Data$dEq.eqString).eq)();
const eq4 = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
const eq9 = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
const eq10 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dPreorderSettings.eqPreorderSettings.eq(x._1)(y._1); }
    return false;
  }
  return false;
};
const eq12 = /* #__PURE__ */ (() => Data$dMap$dInternal.eqMap(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.eqMenuConsumer)(Data$dEq.eqUnit).eq)();
const customParameterValuesIsSymbol = {reflectSymbol: () => "customParameterValues"};
const itemProductIsSymbol = {reflectSymbol: () => "itemProduct"};
const showMap = /* #__PURE__ */ Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Data$dUUID.showUUID);
const SingleProductIsSymbol = {reflectSymbol: () => "SingleProduct"};
const comboIsSymbol = {reflectSymbol: () => "combo"};
const ProductComboIsSymbol = {reflectSymbol: () => "ProductCombo"};
const creatorDescriptionIsSymbol = {reflectSymbol: () => "creatorDescription"};
const creatorNameIsSymbol = {reflectSymbol: () => "creatorName"};
const creatorPhotoIsSymbol = {reflectSymbol: () => "creatorPhoto"};
const creatorProductsIsSymbol = {reflectSymbol: () => "creatorProducts"};
const showMaybe = {
  show: v => {
    if (v.tag === "Just") { return "(Just " + Restaumatic$dMenu$dV2$dTypes$dPhoto.showPhoto.show(v._1) + ")"; }
    if (v.tag === "Nothing") { return "Nothing"; }
    $runtime.fail();
  }
};
const showTranslated = /* #__PURE__ */ Data$dMap$dInternal.showMap(Restaumatic$dLocales.showLocale)(Data$dShow.showString);
const ProductCreatorIsSymbol = {reflectSymbol: () => "ProductCreator"};
const itemsIsSymbol = {reflectSymbol: () => "items"};
const ProductsIsSymbol = {reflectSymbol: () => "Products"};
const howManyIsSymbol = {reflectSymbol: () => "howMany"};
const MostPopularIsSymbol = {reflectSymbol: () => "MostPopular"};
const GenericFormulaIsSymbol = {reflectSymbol: () => "GenericFormula"};
const ArbitraryHtmlIsSymbol = {reflectSymbol: () => "ArbitraryHtml"};
const decodeRecordCons = /* #__PURE__ */ Unscramble.decodeRecordCons(customParameterValuesIsSymbol)(/* #__PURE__ */ Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Data$dUUID.udecodeUUID));
const udecodeTranslated = /* #__PURE__ */ Restaumatic$dI18n$dTypes.decodeMap(Unscramble.decodeString1);
const decodeMaybe = /* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dPhoto.unscrambleDecodePhoto);
const colorIsSymbol = {reflectSymbol: () => "color"};
const columnParameterIsSymbol = {reflectSymbol: () => "columnParameter"};
const contentIsSymbol = {reflectSymbol: () => "content"};
const defaultCategoryIsSymbol = {reflectSymbol: () => "defaultCategory"};
const descriptionIsSymbol = {reflectSymbol: () => "description"};
const dropdownParametersIsSymbol = {reflectSymbol: () => "dropdownParameters"};
const nameIsSymbol = {reflectSymbol: () => "name"};
const photoIsSymbol = {reflectSymbol: () => "photo"};
const preorderSettingsIsSymbol = {reflectSymbol: () => "preorderSettings"};
const visibilityScheduleIsSymbol = {reflectSymbol: () => "visibilitySchedule"};
const visibleIsSymbol = {reflectSymbol: () => "visible"};
const visibleInIsSymbol = {reflectSymbol: () => "visibleIn"};
const MenuSectionIsSymbol = {reflectSymbol: () => "MenuSection"};
const decodeMaybe1 = /* #__PURE__ */ Unscramble.decodeMaybe(Data$dUUID.udecodeUUID);
const encodeWithOptionsOther = {encodeWithOptions: v => Data$dUUID.encodeUUID.encode};
const genericEncodeArgsArgument = {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)};
const encodeWithOptionsOther1 = /* #__PURE__ */ (() => {
  const encode1 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dUUID.encodeUUID)(genericEncodeArgsArgument).encode;
  return {encodeWithOptions: v => encode1};
})();
const encodeWithOptionsOther2 = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") {
      return Foreign$dGeneric$dClass.genericEncodeConstructor(Restaumatic$dMenu$dV2$dTypes$dPhoto.PhotoIsSymbol)({
        encodeArgs: opts => v$1 => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v$1), Data$dList$dTypes.Nil)
      }).encodeOpts(Foreign$dEncoding.options)(v2._1);
    }
    $runtime.fail();
  }
};
const encodeWithOptionsOther3 = /* #__PURE__ */ (() => {
  const encode1 = Restaumatic$dI18n$dTypes.encodeTranslated(Foreign$dGeneric$dClass.stringEncode).encode;
  return {encodeWithOptions: v => encode1};
})();
const encodeWithOptionsOther4 = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
};
const decodeWithOptionsOther = {decodeWithOptions: v => Data$dUUID.decodeUUID.decode};
const genericDecodeArgsArgument = {decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument(decodeWithOptionsOther), decodeSingleRecordArg: Data$dMaybe.Nothing};
const decodeWithOptionsOther1 = /* #__PURE__ */ (() => {
  const decode2 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dUUID.decodeUUID)(genericDecodeArgsArgument).decode;
  return {decodeWithOptions: v => decode2};
})();
const decodeWithOptionsOther2 = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dPhoto.decodePhoto.decode)};
const decodeWithOptionsOther3 = /* #__PURE__ */ (() => {
  const decode2 = Restaumatic$dI18n$dTypes.decodeTranslated(Foreign$dGeneric$dClass.stringDecode).decode;
  return {decodeWithOptions: v => decode2};
})();
const decodeWithOptionsOther4 = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUUID.decodeUUID.decode)};
const SingleProduct = value0 => $MenuSectionItem("SingleProduct", value0);
const ProductCombo = value0 => $MenuSectionItem("ProductCombo", value0);
const ProductCreator = value0 => $MenuSectionItem("ProductCreator", value0);
const Products = value0 => $SectionContent("Products", value0);
const MostPopular = value0 => $SectionContent("MostPopular", value0);
const GenericFormula = /* #__PURE__ */ $SectionContent("GenericFormula");
const ArbitraryHtml = value0 => $SectionContent("ArbitraryHtml", value0);
const MenuSection = x => x;
const toFillFormTypeSectionCont = {fillFormDataType: v => "unknown"};
const toFillFormTypeMenuSection = {fillFormDataType: v => "unknown"};
const toFillFormTypeMenuSection1 = {fillFormDataType: v => "unknown"};
const newtypeMenuSection_ = {Coercible0: () => {}};
const hasFieldMenuSection = dictHasField => dictHasField;
const eqMenuSectionItem = {
  eq: x => y => {
    if (x.tag === "SingleProduct") {
      if (y.tag === "SingleProduct") { return eq(x._1.customParameterValues)(y._1.customParameterValues) && x._1.itemProduct === y._1.itemProduct; }
      return false;
    }
    if (x.tag === "ProductCombo") {
      if (y.tag === "ProductCombo") { return x._1.combo === y._1.combo; }
      return false;
    }
    if (x.tag === "ProductCreator") {
      if (y.tag === "ProductCreator") {
        return eq2(x._1.creatorDescription)(y._1.creatorDescription) && eq2(x._1.creatorName)(y._1.creatorName) && (() => {
          if (x._1.creatorPhoto.tag === "Nothing") { return y._1.creatorPhoto.tag === "Nothing"; }
          if (x._1.creatorPhoto.tag === "Just") {
            if (y._1.creatorPhoto.tag === "Just") { return x._1.creatorPhoto._1 === y._1.creatorPhoto._1; }
            return false;
          }
          return false;
        })() && eq4(x._1.creatorProducts)(y._1.creatorProducts);
      }
      return false;
    }
    return false;
  }
};
const eq13 = /* #__PURE__ */ (() => Data$dMap$dOrdered.eqOMap(Data$dEq.eqString)(eqMenuSectionItem).eq)();
const eqSectionContent = {
  eq: x => y => {
    if (x.tag === "Products") {
      if (y.tag === "Products") { return eq13(x._1.items)(y._1.items); }
      return false;
    }
    if (x.tag === "MostPopular") {
      if (y.tag === "MostPopular") { return x._1.howMany === y._1.howMany; }
      return false;
    }
    if (x.tag === "GenericFormula") { return y.tag === "GenericFormula"; }
    if (x.tag === "ArbitraryHtml") {
      if (y.tag === "ArbitraryHtml") { return x._1 === y._1; }
      return false;
    }
    return false;
  }
};
const eqMenuSection = {
  eq: x => y => (() => {
    if (x.color.tag === "Nothing") { return y.color.tag === "Nothing"; }
    if (x.color.tag === "Just") {
      if (y.color.tag === "Just") { return x.color._1 === y.color._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.columnParameter.tag === "Nothing") { return y.columnParameter.tag === "Nothing"; }
    if (x.columnParameter.tag === "Just") {
      if (y.columnParameter.tag === "Just") { return x.columnParameter._1 === y.columnParameter._1; }
      return false;
    }
    return false;
  })() && eqSectionContent.eq(x.content)(y.content) && eq(x.customParameterValues)(y.customParameterValues) && (() => {
    if (x.defaultCategory.tag === "Nothing") { return y.defaultCategory.tag === "Nothing"; }
    if (x.defaultCategory.tag === "Just") {
      if (y.defaultCategory.tag === "Just") { return x.defaultCategory._1 === y.defaultCategory._1; }
      return false;
    }
    return false;
  })() && eq2(x.description)(y.description) && eq9(x.dropdownParameters)(y.dropdownParameters) && eq2(x.name)(y.name) && (() => {
    if (x.photo.tag === "Nothing") { return y.photo.tag === "Nothing"; }
    if (x.photo.tag === "Just") {
      if (y.photo.tag === "Just") { return x.photo._1 === y.photo._1; }
      return false;
    }
    return false;
  })() && eq10(x.preorderSettings)(y.preorderSettings) && (() => {
    if (x.visibilitySchedule.tag === "Nothing") { return y.visibilitySchedule.tag === "Nothing"; }
    if (x.visibilitySchedule.tag === "Just") {
      if (y.visibilitySchedule.tag === "Just") { return x.visibilitySchedule._1 === y.visibilitySchedule._1; }
      return false;
    }
    return false;
  })() && x.visible === y.visible && eq12(x.visibleIn)(y.visibleIn)
};
const genericSectionContent = {
  to: x => {
    if (x.tag === "Inl") { return $SectionContent("Products", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $SectionContent("MostPopular", x._1._1); }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return GenericFormula; }
        if (x._1._1.tag === "Inr") { return $SectionContent("ArbitraryHtml", x._1._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Products") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "MostPopular") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "GenericFormula") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "ArbitraryHtml") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1))); }
    $runtime.fail();
  }
};
const genericMenuSectionItem = {
  to: x => {
    if (x.tag === "Inl") { return $MenuSectionItem("SingleProduct", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $MenuSectionItem("ProductCombo", x._1._1); }
      if (x._1.tag === "Inr") { return $MenuSectionItem("ProductCreator", x._1._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "SingleProduct") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "ProductCombo") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "ProductCreator") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)); }
    $runtime.fail();
  }
};
const showMenuSectionItem = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => ["{ customParameterValues: " + showMap.show(v.customParameterValues) + ", itemProduct: " + v.itemProduct + " " + "}"]
    })(SingleProductIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{ combo: " + v.combo + " }"]})(ProductComboIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $2 = Data$dArray$dNonEmpty$dInternal.showNonEmptyArray(Data$dUUID.showUUID);
      return {
        genericShowArgs: v => [
          "{ creatorDescription: " + showTranslated.show(v.creatorDescription) + ", creatorName: " + showTranslated.show(v.creatorName) + ", creatorPhoto: " + showMaybe.show(v.creatorPhoto) + ", creatorProducts: " + $2.show(v.creatorProducts) + " " + "}"
        ]
      };
    })())(ProductCreatorIsSymbol);
    return x => {
      const $3 = genericMenuSectionItem.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const showSectionContent = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dOrdered.showOMap(Data$dUUID.showUUID)(showMenuSectionItem);
      return {genericShowArgs: v => ["{ items: " + $0.show(v.items) + " }"]};
    })())(ProductsIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{ howMany: " + Data$dShow.showIntImpl(v.howMany) + " }"]})(MostPopularIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(GenericFormulaIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showStringImpl(v)]})(ArbitraryHtmlIsSymbol);
    return x => {
      const $4 = genericSectionContent.from(x);
      if ($4.tag === "Inl") { return $0["genericShow'"]($4._1); }
      if ($4.tag === "Inr") {
        if ($4._1.tag === "Inl") { return $1["genericShow'"]($4._1._1); }
        if ($4._1.tag === "Inr") {
          if ($4._1._1.tag === "Inl") { return $2["genericShow'"]($4._1._1._1); }
          if ($4._1._1.tag === "Inr") { return $3["genericShow'"]($4._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeMenuSectionItem = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(SingleProductIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(decodeRecordCons(Unscramble.decodeRecordCons(itemProductIsSymbol)(Data$dUUID.udecodeUUID)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(ProductComboIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(comboIsSymbol)(Data$dUUID.udecodeUUID)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumConstruct(ProductCreatorIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(creatorDescriptionIsSymbol)(udecodeTranslated)(Unscramble.decodeRecordCons(creatorNameIsSymbol)(udecodeTranslated)(Unscramble.decodeRecordCons(creatorPhotoIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(creatorProductsIsSymbol)(Unscramble.decodeNonEmptyArray(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordNil)))).recordInfo(Type$dProxy.Proxy))
    }))))(Unscramble$dGeneric.defaultOptions);
    return x => genericMenuSectionItem.to($0(x));
  })()
};
const unscrambleDecodeSectionContent = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(ProductsIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(itemsIsSymbol)(Data$dMap$dOrdered.udecodeMap(unscrambleDecodeMenuSectionItem)(Data$dUUID.udecodeUUID)(Data$dOrd.ordString))(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(MostPopularIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(howManyIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(GenericFormulaIsSymbol))(Unscramble$dGeneric.genericDecodeSumConstruct(ArbitraryHtmlIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Unscramble.decodeString(x.contents)
    })))))(Unscramble$dGeneric.defaultOptions);
    return x => genericSectionContent.to($0(x));
  })()
};
const genericMenuSection = {to: x => x, from: x => x};
const showMenuSection = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dSet.showSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.showMenuConsumer);
      const $1 = Data$dShow.showArrayImpl(Data$dUUID.toString);
      return {
        genericShowArgs: v => [
          (() => {
            if (v.color.tag === "Just") {
              return "{" + " color: (Just " + Restaumatic$dMenu$dV2$dTypes$dColor.showColor.show(v.color._1) + ")" + (() => {
                if (v.columnParameter.tag === "Just") {
                  return ", columnParameter: (Just " + v.columnParameter._1 + ")" + ", content: " + showSectionContent.show(v.content) + ", customParameterValues: " + showMap.show(v.customParameterValues) + (() => {
                    if (v.defaultCategory.tag === "Just") {
                      return ", defaultCategory: (Just " + v.defaultCategory._1 + ")" + ", description: " + showTranslated.show(v.description) + ", dropdownParameters: " + $1(v.dropdownParameters) + ", name: " + showTranslated.show(v.name) + ", photo: " + showMaybe.show(v.photo) + (() => {
                        if (v.preorderSettings.tag === "Just") {
                          return ", preorderSettings: (Just " + Restaumatic$dMenu$dV2$dTypes$dPreorderSettings.showPreorderSettings.show(v.preorderSettings._1) + ")" + (() => {
                            if (v.visibilitySchedule.tag === "Just") {
                              return ", visibilitySchedule: (Just " + v.visibilitySchedule._1 + ")" + (v.visible
                                ? ", visible: true, visibleIn: " + $0.show(v.visibleIn) + " "
                                : ", visible: false, visibleIn: " + $0.show(v.visibleIn) + " ");
                            }
                            if (v.visibilitySchedule.tag === "Nothing") {
                              if (v.visible) { return ", visibilitySchedule: Nothing, visible: true, visibleIn: " + $0.show(v.visibleIn) + " "; }
                              return ", visibilitySchedule: Nothing, visible: false, visibleIn: " + $0.show(v.visibleIn) + " ";
                            }
                            $runtime.fail();
                          })();
                        }
                        if (v.preorderSettings.tag === "Nothing") {
                          if (v.visibilitySchedule.tag === "Just") {
                            return ", preorderSettings: Nothing, visibilitySchedule: (Just " + v.visibilitySchedule._1 + ")" + (v.visible
                              ? ", visible: true, visibleIn: " + $0.show(v.visibleIn) + " "
                              : ", visible: false, visibleIn: " + $0.show(v.visibleIn) + " ");
                          }
                          if (v.visibilitySchedule.tag === "Nothing") {
                            if (v.visible) { return ", preorderSettings: Nothing, visibilitySchedule: Nothing, visible: true, visibleIn: " + $0.show(v.visibleIn) + " "; }
                            return ", preorderSettings: Nothing, visibilitySchedule: Nothing, visible: false, visibleIn: " + $0.show(v.visibleIn) + " ";
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      })();
                    }
                    if (v.defaultCategory.tag === "Nothing") {
                      return ", defaultCategory: Nothing, description: " + showTranslated.show(v.description) + ", dropdownParameters: " + $1(v.dropdownParameters) + ", name: " + showTranslated.show(v.name) + ", photo: " + showMaybe.show(v.photo) + (() => {
                        if (v.preorderSettings.tag === "Just") {
                          return ", preorderSettings: (Just " + Restaumatic$dMenu$dV2$dTypes$dPreorderSettings.showPreorderSettings.show(v.preorderSettings._1) + ")" + (() => {
                            if (v.visibilitySchedule.tag === "Just") {
                              return ", visibilitySchedule: (Just " + v.visibilitySchedule._1 + ")" + (v.visible
                                ? ", visible: true, visibleIn: " + $0.show(v.visibleIn) + " "
                                : ", visible: false, visibleIn: " + $0.show(v.visibleIn) + " ");
                            }
                            if (v.visibilitySchedule.tag === "Nothing") {
                              if (v.visible) { return ", visibilitySchedule: Nothing, visible: true, visibleIn: " + $0.show(v.visibleIn) + " "; }
                              return ", visibilitySchedule: Nothing, visible: false, visibleIn: " + $0.show(v.visibleIn) + " ";
                            }
                            $runtime.fail();
                          })();
                        }
                        if (v.preorderSettings.tag === "Nothing") {
                          if (v.visibilitySchedule.tag === "Just") {
                            return ", preorderSettings: Nothing, visibilitySchedule: (Just " + v.visibilitySchedule._1 + ")" + (v.visible
                              ? ", visible: true, visibleIn: " + $0.show(v.visibleIn) + " "
                              : ", visible: false, visibleIn: " + $0.show(v.visibleIn) + " ");
                          }
                          if (v.visibilitySchedule.tag === "Nothing") {
                            if (v.visible) { return ", preorderSettings: Nothing, visibilitySchedule: Nothing, visible: true, visibleIn: " + $0.show(v.visibleIn) + " "; }
                            return ", preorderSettings: Nothing, visibilitySchedule: Nothing, visible: false, visibleIn: " + $0.show(v.visibleIn) + " ";
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      })();
                    }
                    $runtime.fail();
                  })();
                }
                if (v.columnParameter.tag === "Nothing") {
                  return ", columnParameter: Nothing, content: " + showSectionContent.show(v.content) + ", customParameterValues: " + showMap.show(v.customParameterValues) + (() => {
                    if (v.defaultCategory.tag === "Just") {
                      return ", defaultCategory: (Just " + v.defaultCategory._1 + ")" + ", description: " + showTranslated.show(v.description) + ", dropdownParameters: " + $1(v.dropdownParameters) + ", name: " + showTranslated.show(v.name) + ", photo: " + showMaybe.show(v.photo) + (() => {
                        if (v.preorderSettings.tag === "Just") {
                          return ", preorderSettings: (Just " + Restaumatic$dMenu$dV2$dTypes$dPreorderSettings.showPreorderSettings.show(v.preorderSettings._1) + ")" + (() => {
                            if (v.visibilitySchedule.tag === "Just") {
                              return ", visibilitySchedule: (Just " + v.visibilitySchedule._1 + ")" + (v.visible
                                ? ", visible: true, visibleIn: " + $0.show(v.visibleIn) + " "
                                : ", visible: false, visibleIn: " + $0.show(v.visibleIn) + " ");
                            }
                            if (v.visibilitySchedule.tag === "Nothing") {
                              if (v.visible) { return ", visibilitySchedule: Nothing, visible: true, visibleIn: " + $0.show(v.visibleIn) + " "; }
                              return ", visibilitySchedule: Nothing, visible: false, visibleIn: " + $0.show(v.visibleIn) + " ";
                            }
                            $runtime.fail();
                          })();
                        }
                        if (v.preorderSettings.tag === "Nothing") {
                          if (v.visibilitySchedule.tag === "Just") {
                            return ", preorderSettings: Nothing, visibilitySchedule: (Just " + v.visibilitySchedule._1 + ")" + (v.visible
                              ? ", visible: true, visibleIn: " + $0.show(v.visibleIn) + " "
                              : ", visible: false, visibleIn: " + $0.show(v.visibleIn) + " ");
                          }
                          if (v.visibilitySchedule.tag === "Nothing") {
                            if (v.visible) { return ", preorderSettings: Nothing, visibilitySchedule: Nothing, visible: true, visibleIn: " + $0.show(v.visibleIn) + " "; }
                            return ", preorderSettings: Nothing, visibilitySchedule: Nothing, visible: false, visibleIn: " + $0.show(v.visibleIn) + " ";
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      })();
                    }
                    if (v.defaultCategory.tag === "Nothing") {
                      return ", defaultCategory: Nothing, description: " + showTranslated.show(v.description) + ", dropdownParameters: " + $1(v.dropdownParameters) + ", name: " + showTranslated.show(v.name) + ", photo: " + showMaybe.show(v.photo) + (() => {
                        if (v.preorderSettings.tag === "Just") {
                          return ", preorderSettings: (Just " + Restaumatic$dMenu$dV2$dTypes$dPreorderSettings.showPreorderSettings.show(v.preorderSettings._1) + ")" + (() => {
                            if (v.visibilitySchedule.tag === "Just") {
                              return ", visibilitySchedule: (Just " + v.visibilitySchedule._1 + ")" + (v.visible
                                ? ", visible: true, visibleIn: " + $0.show(v.visibleIn) + " "
                                : ", visible: false, visibleIn: " + $0.show(v.visibleIn) + " ");
                            }
                            if (v.visibilitySchedule.tag === "Nothing") {
                              if (v.visible) { return ", visibilitySchedule: Nothing, visible: true, visibleIn: " + $0.show(v.visibleIn) + " "; }
                              return ", visibilitySchedule: Nothing, visible: false, visibleIn: " + $0.show(v.visibleIn) + " ";
                            }
                            $runtime.fail();
                          })();
                        }
                        if (v.preorderSettings.tag === "Nothing") {
                          if (v.visibilitySchedule.tag === "Just") {
                            return ", preorderSettings: Nothing, visibilitySchedule: (Just " + v.visibilitySchedule._1 + ")" + (v.visible
                              ? ", visible: true, visibleIn: " + $0.show(v.visibleIn) + " "
                              : ", visible: false, visibleIn: " + $0.show(v.visibleIn) + " ");
                          }
                          if (v.visibilitySchedule.tag === "Nothing") {
                            if (v.visible) { return ", preorderSettings: Nothing, visibilitySchedule: Nothing, visible: true, visibleIn: " + $0.show(v.visibleIn) + " "; }
                            return ", preorderSettings: Nothing, visibilitySchedule: Nothing, visible: false, visibleIn: " + $0.show(v.visibleIn) + " ";
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      })();
                    }
                    $runtime.fail();
                  })();
                }
                $runtime.fail();
              })() + "}";
            }
            if (v.color.tag === "Nothing") {
              if (v.columnParameter.tag === "Just") {
                return "{" + " color: Nothing, columnParameter: (Just " + v.columnParameter._1 + ")" + ", content: " + showSectionContent.show(v.content) + ", customParameterValues: " + showMap.show(v.customParameterValues) + (() => {
                  if (v.defaultCategory.tag === "Just") {
                    return ", defaultCategory: (Just " + v.defaultCategory._1 + ")" + ", description: " + showTranslated.show(v.description) + ", dropdownParameters: " + $1(v.dropdownParameters) + ", name: " + showTranslated.show(v.name) + ", photo: " + showMaybe.show(v.photo) + (() => {
                      if (v.preorderSettings.tag === "Just") {
                        return ", preorderSettings: (Just " + Restaumatic$dMenu$dV2$dTypes$dPreorderSettings.showPreorderSettings.show(v.preorderSettings._1) + ")" + (() => {
                          if (v.visibilitySchedule.tag === "Just") {
                            return ", visibilitySchedule: (Just " + v.visibilitySchedule._1 + ")" + (v.visible
                              ? ", visible: true, visibleIn: " + $0.show(v.visibleIn) + " "
                              : ", visible: false, visibleIn: " + $0.show(v.visibleIn) + " ");
                          }
                          if (v.visibilitySchedule.tag === "Nothing") {
                            if (v.visible) { return ", visibilitySchedule: Nothing, visible: true, visibleIn: " + $0.show(v.visibleIn) + " "; }
                            return ", visibilitySchedule: Nothing, visible: false, visibleIn: " + $0.show(v.visibleIn) + " ";
                          }
                          $runtime.fail();
                        })();
                      }
                      if (v.preorderSettings.tag === "Nothing") {
                        if (v.visibilitySchedule.tag === "Just") {
                          return ", preorderSettings: Nothing, visibilitySchedule: (Just " + v.visibilitySchedule._1 + ")" + (v.visible
                            ? ", visible: true, visibleIn: " + $0.show(v.visibleIn) + " "
                            : ", visible: false, visibleIn: " + $0.show(v.visibleIn) + " ");
                        }
                        if (v.visibilitySchedule.tag === "Nothing") {
                          if (v.visible) { return ", preorderSettings: Nothing, visibilitySchedule: Nothing, visible: true, visibleIn: " + $0.show(v.visibleIn) + " "; }
                          return ", preorderSettings: Nothing, visibilitySchedule: Nothing, visible: false, visibleIn: " + $0.show(v.visibleIn) + " ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    })();
                  }
                  if (v.defaultCategory.tag === "Nothing") {
                    return ", defaultCategory: Nothing, description: " + showTranslated.show(v.description) + ", dropdownParameters: " + $1(v.dropdownParameters) + ", name: " + showTranslated.show(v.name) + ", photo: " + showMaybe.show(v.photo) + (() => {
                      if (v.preorderSettings.tag === "Just") {
                        return ", preorderSettings: (Just " + Restaumatic$dMenu$dV2$dTypes$dPreorderSettings.showPreorderSettings.show(v.preorderSettings._1) + ")" + (() => {
                          if (v.visibilitySchedule.tag === "Just") {
                            return ", visibilitySchedule: (Just " + v.visibilitySchedule._1 + ")" + (v.visible
                              ? ", visible: true, visibleIn: " + $0.show(v.visibleIn) + " "
                              : ", visible: false, visibleIn: " + $0.show(v.visibleIn) + " ");
                          }
                          if (v.visibilitySchedule.tag === "Nothing") {
                            if (v.visible) { return ", visibilitySchedule: Nothing, visible: true, visibleIn: " + $0.show(v.visibleIn) + " "; }
                            return ", visibilitySchedule: Nothing, visible: false, visibleIn: " + $0.show(v.visibleIn) + " ";
                          }
                          $runtime.fail();
                        })();
                      }
                      if (v.preorderSettings.tag === "Nothing") {
                        if (v.visibilitySchedule.tag === "Just") {
                          return ", preorderSettings: Nothing, visibilitySchedule: (Just " + v.visibilitySchedule._1 + ")" + (v.visible
                            ? ", visible: true, visibleIn: " + $0.show(v.visibleIn) + " "
                            : ", visible: false, visibleIn: " + $0.show(v.visibleIn) + " ");
                        }
                        if (v.visibilitySchedule.tag === "Nothing") {
                          if (v.visible) { return ", preorderSettings: Nothing, visibilitySchedule: Nothing, visible: true, visibleIn: " + $0.show(v.visibleIn) + " "; }
                          return ", preorderSettings: Nothing, visibilitySchedule: Nothing, visible: false, visibleIn: " + $0.show(v.visibleIn) + " ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    })();
                  }
                  $runtime.fail();
                })() + "}";
              }
              if (v.columnParameter.tag === "Nothing") {
                return "{ color: Nothing, columnParameter: Nothing, content: " + showSectionContent.show(v.content) + ", customParameterValues: " + showMap.show(v.customParameterValues) + (() => {
                  if (v.defaultCategory.tag === "Just") {
                    return ", defaultCategory: (Just " + v.defaultCategory._1 + ")" + ", description: " + showTranslated.show(v.description) + ", dropdownParameters: " + $1(v.dropdownParameters) + ", name: " + showTranslated.show(v.name) + ", photo: " + showMaybe.show(v.photo) + (() => {
                      if (v.preorderSettings.tag === "Just") {
                        return ", preorderSettings: (Just " + Restaumatic$dMenu$dV2$dTypes$dPreorderSettings.showPreorderSettings.show(v.preorderSettings._1) + ")" + (() => {
                          if (v.visibilitySchedule.tag === "Just") {
                            return ", visibilitySchedule: (Just " + v.visibilitySchedule._1 + ")" + (v.visible
                              ? ", visible: true, visibleIn: " + $0.show(v.visibleIn) + " "
                              : ", visible: false, visibleIn: " + $0.show(v.visibleIn) + " ");
                          }
                          if (v.visibilitySchedule.tag === "Nothing") {
                            if (v.visible) { return ", visibilitySchedule: Nothing, visible: true, visibleIn: " + $0.show(v.visibleIn) + " "; }
                            return ", visibilitySchedule: Nothing, visible: false, visibleIn: " + $0.show(v.visibleIn) + " ";
                          }
                          $runtime.fail();
                        })();
                      }
                      if (v.preorderSettings.tag === "Nothing") {
                        if (v.visibilitySchedule.tag === "Just") {
                          return ", preorderSettings: Nothing, visibilitySchedule: (Just " + v.visibilitySchedule._1 + ")" + (v.visible
                            ? ", visible: true, visibleIn: " + $0.show(v.visibleIn) + " "
                            : ", visible: false, visibleIn: " + $0.show(v.visibleIn) + " ");
                        }
                        if (v.visibilitySchedule.tag === "Nothing") {
                          if (v.visible) { return ", preorderSettings: Nothing, visibilitySchedule: Nothing, visible: true, visibleIn: " + $0.show(v.visibleIn) + " "; }
                          return ", preorderSettings: Nothing, visibilitySchedule: Nothing, visible: false, visibleIn: " + $0.show(v.visibleIn) + " ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    })();
                  }
                  if (v.defaultCategory.tag === "Nothing") {
                    return ", defaultCategory: Nothing, description: " + showTranslated.show(v.description) + ", dropdownParameters: " + $1(v.dropdownParameters) + ", name: " + showTranslated.show(v.name) + ", photo: " + showMaybe.show(v.photo) + (() => {
                      if (v.preorderSettings.tag === "Just") {
                        return ", preorderSettings: (Just " + Restaumatic$dMenu$dV2$dTypes$dPreorderSettings.showPreorderSettings.show(v.preorderSettings._1) + ")" + (() => {
                          if (v.visibilitySchedule.tag === "Just") {
                            return ", visibilitySchedule: (Just " + v.visibilitySchedule._1 + ")" + (v.visible
                              ? ", visible: true, visibleIn: " + $0.show(v.visibleIn) + " "
                              : ", visible: false, visibleIn: " + $0.show(v.visibleIn) + " ");
                          }
                          if (v.visibilitySchedule.tag === "Nothing") {
                            if (v.visible) { return ", visibilitySchedule: Nothing, visible: true, visibleIn: " + $0.show(v.visibleIn) + " "; }
                            return ", visibilitySchedule: Nothing, visible: false, visibleIn: " + $0.show(v.visibleIn) + " ";
                          }
                          $runtime.fail();
                        })();
                      }
                      if (v.preorderSettings.tag === "Nothing") {
                        if (v.visibilitySchedule.tag === "Just") {
                          return ", preorderSettings: Nothing, visibilitySchedule: (Just " + v.visibilitySchedule._1 + ")" + (v.visible
                            ? ", visible: true, visibleIn: " + $0.show(v.visibleIn) + " "
                            : ", visible: false, visibleIn: " + $0.show(v.visibleIn) + " ");
                        }
                        if (v.visibilitySchedule.tag === "Nothing") {
                          if (v.visible) { return ", preorderSettings: Nothing, visibilitySchedule: Nothing, visible: true, visibleIn: " + $0.show(v.visibleIn) + " "; }
                          return ", preorderSettings: Nothing, visibilitySchedule: Nothing, visible: false, visibleIn: " + $0.show(v.visibleIn) + " ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    })();
                  }
                  $runtime.fail();
                })() + "}";
              }
              $runtime.fail();
            }
            $runtime.fail();
          })()
        ]
      };
    })())(MenuSectionIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeMenuSection = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(colorIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dColor.unscrambleDecodeColor))(Unscramble.decodeRecordCons(columnParameterIsSymbol)(decodeMaybe1)(Unscramble.decodeRecordCons(contentIsSymbol)(unscrambleDecodeSectionContent)(decodeRecordCons(Unscramble.decodeRecordCons(defaultCategoryIsSymbol)(decodeMaybe1)(Unscramble.decodeRecordCons(descriptionIsSymbol)(udecodeTranslated)(Unscramble.decodeRecordCons(dropdownParametersIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)
    })(Unscramble.decodeRecordCons(nameIsSymbol)(udecodeTranslated)(Unscramble.decodeRecordCons(photoIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(preorderSettingsIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dPreorderSettings.unscrambleDecodePreorderSettings))(Unscramble.decodeRecordCons(visibilityScheduleIsSymbol)(decodeMaybe1)(Unscramble.decodeRecordCons(visibleIsSymbol)(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons(visibleInIsSymbol)(Unscramble.decodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.unscrambleDecodeMenuConsumer)(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer))(Unscramble.decodeRecordNil))))))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeMenuSectionItem = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericMenuSectionItem)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(SingleProductIsSymbol)((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(itemProductIsSymbol)(encodeWithOptionsOther))(customParameterValuesIsSymbol)(encodeWithOptionsOther1);
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(ProductComboIsSymbol)((() => {
      const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(comboIsSymbol)(encodeWithOptionsOther);
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(ProductCreatorIsSymbol)((() => {
      const $2 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(creatorProductsIsSymbol)((() => {
        const encode1 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
        return {encodeWithOptions: v => encode1};
      })()))(creatorPhotoIsSymbol)(encodeWithOptionsOther2))(creatorNameIsSymbol)(encodeWithOptionsOther3))(creatorDescriptionIsSymbol)(encodeWithOptionsOther3);
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeSectionContent = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericSectionContent)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(ProductsIsSymbol)((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(itemsIsSymbol)((() => {
        const encode1 = Data$dMap$dOrdered.encodeMap({
          encode: Foreign$dEncoding.defaultEncode(Data$dTuple$dT2.genericT2)(Foreign$dGeneric$dClass.genericEncodeConstructor(Data$dTuple$dT2.T2IsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsProduct(genericEncodeArgsArgument)({
            encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encodeMenuSectionItem.encode(v)), Data$dList$dTypes.Nil)
          })))
        }).encode;
        return {encodeWithOptions: v => encode1};
      })());
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(MostPopularIsSymbol)((() => {
      const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(howManyIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(GenericFormulaIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor(ArbitraryHtmlIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") {
            if (v1._1._1.tag === "Inl") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            if (v1._1._1.tag === "Inr") { return $3.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeMenuSection = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericMenuSection)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(MenuSectionIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(visibleInIsSymbol)((() => {
      const encode1 = Data$dSet$dSerialized.encodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.encodeMenuConsumer).encode;
      return {encodeWithOptions: v => encode1};
    })()))(visibleIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))(visibilityScheduleIsSymbol)(encodeWithOptionsOther4))(preorderSettingsIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dPreorderSettings.encodePreorderSettings.encode(v2._1); }
        $runtime.fail();
      }
    }))(photoIsSymbol)(encodeWithOptionsOther2))(nameIsSymbol)(encodeWithOptionsOther3))(dropdownParametersIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
      return {encodeWithOptions: v => encode1};
    })()))(descriptionIsSymbol)(encodeWithOptionsOther3))(defaultCategoryIsSymbol)(encodeWithOptionsOther4))(customParameterValuesIsSymbol)(encodeWithOptionsOther1))(contentIsSymbol)({
      encodeWithOptions: v => encodeSectionContent.encode
    }))(columnParameterIsSymbol)(encodeWithOptionsOther4))(colorIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") {
          return Foreign$dGeneric$dClass.genericEncodeConstructor(Restaumatic$dMenu$dV2$dTypes$dColor.ColorIsSymbol)({
            encodeArgs: opts => v$1 => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v$1), Data$dList$dTypes.Nil)
          }).encodeOpts(Foreign$dEncoding.options)(v2._1);
        }
        $runtime.fail();
      }
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeMenuSectionItem = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericMenuSectionItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(SingleProductIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(itemProductIsSymbol)(decodeWithOptionsOther)())(customParameterValuesIsSymbol)(decodeWithOptionsOther1)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ProductComboIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(comboIsSymbol)(decodeWithOptionsOther)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ProductCreatorIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(creatorProductsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Data$dArray$dNonEmpty$dSerialized.decodeNonEmptyArray(Data$dUUID.decodeUUID).decode;
    return {decodeWithOptions: v => decode2};
  })())())(creatorPhotoIsSymbol)(decodeWithOptionsOther2)())(creatorNameIsSymbol)(decodeWithOptionsOther3)())(creatorDescriptionIsSymbol)(decodeWithOptionsOther3)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))))
};
const decodeSectionContent = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericSectionContent)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ProductsIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(itemsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Data$dMap$dOrdered.decodeMap(Data$dTuple$dT2.decodeT2(genericDecodeArgsArgument)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => decodeMenuSectionItem.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }))(Data$dOrd.ordString).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(MostPopularIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(howManyIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(GenericFormulaIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ArbitraryHtmlIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign$dGeneric$dClass.readString}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument)))))
};
const decodeMenuSection = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericMenuSection)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(MenuSectionIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(visibleInIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Data$dSet$dSerialized.decodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer)(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.decodeMenuConsumer).decode;
    return {decodeWithOptions: v => decode2};
  })())())(visibleIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode})())(visibilityScheduleIsSymbol)(decodeWithOptionsOther4)())(preorderSettingsIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dPreorderSettings.decodePreorderSettings.decode)
  })())(photoIsSymbol)(decodeWithOptionsOther2)())(nameIsSymbol)(decodeWithOptionsOther3)())(dropdownParametersIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID).decode;
    return {decodeWithOptions: v => decode2};
  })())())(descriptionIsSymbol)(decodeWithOptionsOther3)())(defaultCategoryIsSymbol)(decodeWithOptionsOther4)())(customParameterValuesIsSymbol)(decodeWithOptionsOther1)())(contentIsSymbol)({
    decodeWithOptions: v => decodeSectionContent.decode
  })())(columnParameterIsSymbol)(decodeWithOptionsOther4)())(colorIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dColor.decodeColor.decode)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  $MenuSectionItem,
  $SectionContent,
  ArbitraryHtml,
  ArbitraryHtmlIsSymbol,
  GenericFormula,
  GenericFormulaIsSymbol,
  MenuSection,
  MenuSectionIsSymbol,
  MostPopular,
  MostPopularIsSymbol,
  ProductCombo,
  ProductComboIsSymbol,
  ProductCreator,
  ProductCreatorIsSymbol,
  Products,
  ProductsIsSymbol,
  SingleProduct,
  SingleProductIsSymbol,
  colorIsSymbol,
  columnParameterIsSymbol,
  comboIsSymbol,
  contentIsSymbol,
  creatorDescriptionIsSymbol,
  creatorNameIsSymbol,
  creatorPhotoIsSymbol,
  creatorProductsIsSymbol,
  customParameterValuesIsSymbol,
  decodeMaybe,
  decodeMaybe1,
  decodeMenuSection,
  decodeMenuSectionItem,
  decodeRecordCons,
  decodeSectionContent,
  decodeWithOptionsOther,
  decodeWithOptionsOther1,
  decodeWithOptionsOther2,
  decodeWithOptionsOther3,
  decodeWithOptionsOther4,
  defaultCategoryIsSymbol,
  descriptionIsSymbol,
  dropdownParametersIsSymbol,
  encodeMenuSection,
  encodeMenuSectionItem,
  encodeSectionContent,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  encodeWithOptionsOther2,
  encodeWithOptionsOther3,
  encodeWithOptionsOther4,
  eq,
  eq10,
  eq12,
  eq13,
  eq2,
  eq4,
  eq9,
  eqMenuSection,
  eqMenuSectionItem,
  eqSectionContent,
  genericDecodeArgsArgument,
  genericEncodeArgsArgument,
  genericMenuSection,
  genericMenuSectionItem,
  genericSectionContent,
  hasFieldMenuSection,
  howManyIsSymbol,
  itemProductIsSymbol,
  itemsIsSymbol,
  nameIsSymbol,
  newtypeMenuSection_,
  photoIsSymbol,
  preorderSettingsIsSymbol,
  showMap,
  showMaybe,
  showMenuSection,
  showMenuSectionItem,
  showSectionContent,
  showTranslated,
  toFillFormTypeMenuSection,
  toFillFormTypeMenuSection1,
  toFillFormTypeSectionCont,
  udecodeTranslated,
  unscrambleDecodeMenuSection,
  unscrambleDecodeMenuSectionItem,
  unscrambleDecodeSectionContent,
  visibilityScheduleIsSymbol,
  visibleInIsSymbol,
  visibleIsSymbol
};
